import React from 'react';
import dinogoIcon from '../../assets/icons/ic_dinogo.png';

const AvatarDefault = (props) => {
  return (
    <img
      src={dinogoIcon}
      alt=""
      style={{
        maxWidth: 40,
        maxHeight: 40,
        borderRadius: '50%',
      }}
    />
  );
};

export default AvatarDefault;
